import { useDispatch, useSelector } from 'react-redux';
import {
  setFilterDate as setFd,
  setFilterPriceInit as setFpi,
  setFilterPriceFinal as setFpf,
  setFilterEventType as setFet,
  setFilterEventCategory as setFec,
  setFilterEventCity as setFc,
  setFilterEventName as setFen,
  setFilterOffset as setFof,
  setFilterLimit as setFlim,
  increeaseOffset as increeaseOffsetD,
  restore,
} from './filters.slice';

export default function useBillboardFilters() {
  const billboardFilters = useSelector((state) => state.billboardFilters);

  const dispatch = useDispatch();

  const setFilterDate = (value) => {
    dispatch(setFd(value));
  };

  const setFilterPriceInit = (value) => {
    dispatch(setFpi(value));
  };

  const setFilterPriceFinal = (value) => {
    dispatch(setFpf(value));
  };

  const setFilterEventType = (value) => {
    dispatch(setFet(value));
  };

  const setFilterEventCategory = (value) => {
    dispatch(setFec(value));
  };

  const setFilterEventCity = (value) => {
    dispatch(setFc(value));
  };

  const setFilterEventName = (value) => {
    dispatch(setFen(value));
  };

  const setFilterOffset = (value) => {
    dispatch(setFof(value));
  };

  const setFilterLimit = (value) => {
    dispatch(setFlim(value));
  };

  const clearFilter = () => {
    dispatch(restore());
  };

  const increeaseOffset = () => {
    dispatch(increeaseOffsetD());
  };

  const isFiltering = () => {
    return (
      billboardFilters.date ||
      billboardFilters.price_init ||
      billboardFilters.price_final ||
      billboardFilters.event_type ||
      billboardFilters.event_category ||
      billboardFilters.event_city ||
      billboardFilters.event_name
    );
  };

  return {
    billboardFilters,
    setFilterDate,
    setFilterPriceInit,
    setFilterPriceFinal,
    setFilterEventType,
    setFilterEventCategory,
    setFilterEventCity,
    setFilterEventName,
    setFilterOffset,
    setFilterLimit,
    clearFilter,
    isFiltering,
    increeaseOffset,
  };

}